import { observer } from "mobx-react-lite";
import React, { FC, ReactNode } from "react";
import { setClass, useViewModel } from "../../utils";
import { Filter, FilterViewModel } from "../filter";

interface PageWithFilter {
  children: ReactNode;
  filterVisibility?: boolean;
}

export const PageWrapper: FC<PageWithFilter> = observer(({ children, filterVisibility: filter = false }) => {
  const filterVM = useViewModel(FilterViewModel);
  
  return (
    <div className='main-wrapper'>
      {filter && <Filter />}
      <div className={setClass('page-wrapper', !(filter && filterVM.openPanel) && 'wide-margin')}>
        {children}
      </div>
    </div>
  )
});
